import type { Transaction } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';
import type { AddressFragments } from '../address/types';
import { isValidAddress } from '../address/isValidAddress';

export type AddressProperty = keyof {
    [P in keyof Transaction as Transaction[P] extends AddressFragments | undefined
        ? P
        : never]: any;
};

export const hasAddress =
    (field: AddressProperty): TransactionPredicate =>
    (transaction: Transaction) =>
        isValidAddress(transaction[field]);
